import HSLColor from '../classes/hsl-color';
import minMax from '../helpers/min-max';

const hsb2hsl = ({ hue: h, saturation, brightness, alpha }) => {
  const l = minMax(((2 - saturation) * brightness) / 2, 0, 1);
  let s = 0;
  if (l > 0 && l < 1) {
    s = (saturation * brightness) / (l < 0.5 ? 2 * l : 2 - 2 * l);
  }

  s = minMax(s, 0, 1);
  return new HSLColor(h, s, l, alpha);
};

export default hsb2hsl;
